import { useContext } from 'react';
import { AttachmentsContext } from './Provider';
export const useAttachments = () => {
    const context = useContext(AttachmentsContext);
    if (!context) {
        throw new Error('useAttachments hook must be used as a child to <AttachmentsProvider />');
    }
    return context;
};
